import Model from './download-voucher.model'
import html2canvas from 'html2canvas'
const QRCode = require('qrcode')

let storeContent = utils.generateStore({
   Model,
   voucher: null,
   is_valid: false,
})

export default {
   state() {
      return {
         ...storeContent.state
      };
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async fetchData(ctx) {
         try {
            // await ctx.dispatch('fetchVouchers')
            Event.$emit('loader:show', false)
         } catch (err) {
            throw err
         }
      },
      async validateVoucher(ctx,payload) {
         try {
            if(await payload.ref.isValid()){
               let res = await api.fetchEndpoint({
                  resource: 'coupon',
                  action: 'get:voucher_card',
                  data: {
                     id: payload.id,
                     pass_code: payload.ref.form_data_.pass_code
                  },
                  meta_data: {}
               })

               if(res.result.voucher_card){
                  ctx.commit('voucher',res.result.voucher_card)
                  ctx.commit('is_valid',true)

                  let canvas = document.getElementById('qr-canvas')
                  QRCode.toCanvas(canvas, res.result.voucher_card.code, function (error) {
                     if (error) console.error(error)
                     console.log('success!');
                  })
               }
            }
         } catch (err) {
            throw err
         }
      },
      async downloadVoucher(ctx,payload){
         try {
            let voucher_card = document.querySelector('.voucher-card')

            const printCanvas = await html2canvas(voucher_card, {
               type: "dataURL",
               scrollX: -window.scrollX,
               scrollY: -window.scrollY,
               windowWidth: window.innerWidth,
               windowHeight: voucher_card.offsetHeight,
               scale: 0.9
            });

            const link = document.createElement("a");
            link.setAttribute("download", `${payload.id}-voucher.png`);
            link.setAttribute("href", printCanvas.toDataURL("image/png").replace("image/png", "image/octet-stream"));
            link.click();
         } catch (err) {
            throw err
         }
      },
   }
}